import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var Table = function Table(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(Table.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, children);
};

Table.displayName = "Table";
export default Table;